import { MainMenu } from 'rangeConfig/@types';
import ProductList from 'rangeConfig/shared/widgets/ProductList';
import ProductSwiper from 'rangeConfig/shared/widgets/ProductSwiper';
import withProducts from 'rangeConfig/shared/widgets/withProducts';
import { cabinetsProductListConfig } from './productListConfig';
import platform from 'rangeConfig/shared/utils/platform';

const widgets = {
  desktop: [
    {
      id: 'cabinets-product-list',
      component: withProducts(ProductList, cabinetsProductListConfig)
    }
  ],
  mobile: [
    {
      id: 'cabinets-product-list',
      component: withProducts(ProductSwiper, cabinetsProductListConfig),
      title: 'storageone.productListCabinetsTitle'
    }
  ]
};

const filters = {
  desktop: [],
  mobile: []
};

const mainMenu: MainMenu = {
  menuTitle: 'storageone.productListCabinetsTitle',
  behaviors: {
    productGroupEntered: [],
    productGroupExited: []
  },
  filters: filters[platform],
  widgets: widgets[platform]
};

export default mainMenu;
